import { useState, useEffect } from "react";

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleWhatsAppClick = () => {
    try {
      if (
        typeof window !== "undefined" &&
        typeof (window as any).gtag_report_conversion === "function"
      ) {
        (window as any).gtag_report_conversion();
      }
      window.open(
        "https://wa.me/5512997213362?text=Ol%C3%A1%20Dr.%20Gabriel%2C%20vim%20pelo%20site%20e%20quero%20analisar%20meu%20caso%20de%20bloqueio%20judicial",
        "_blank",
        "noopener,noreferrer"
      );
    } catch (error) {
      console.error("Failed to open WhatsApp link:", error);
    }
  };

  const scrollToContato = () => {
    const target = document.getElementById("contato");
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToSection = (id: string) => {
    setMobileMenuOpen(false);
    const target = document.getElementById(id);
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      {/* Navbar */}
      <nav
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
          scrolled ? "bg-white shadow-md py-3" : "bg-transparent py-5"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
          {/* Logo */}
          <a href="/" className="flex items-center cursor-pointer">
            <h1>
              <img
                src="https://static.readdy.ai/image/bbb32f62fa49874c503b49ff6a2b85c0/9c9337ccdb8d6027eb0c0b5c7b5cb907.png"
                alt="G | A Advocacia"
                className="h-36 w-auto"
                style={{
                  filter: scrolled
                    ? "none"
                    : "drop-shadow(0 0 8px rgba(255,255,255,0.9)) drop-shadow(0 0 15px rgba(255,255,255,0.6))",
                }}
              />
            </h1>
          </a>

          {/* Desktop Nav Links */}
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className={`text-sm font-medium transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                scrolled
                  ? "text-gray-700 hover:text-gray-900"
                  : "text-gray-200 hover:text-white"
              }`}
            >
              Início
            </button>
            <button
              onClick={() => scrollToSection("sobre")}
              className={`text-sm font-medium transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                scrolled
                  ? "text-gray-700 hover:text-gray-900"
                  : "text-gray-200 hover:text-white"
              }`}
            >
              Sobre
            </button>
            <button
              onClick={() => scrollToSection("areas-atuacao")}
              className={`text-sm font-medium transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                scrolled
                  ? "text-gray-700 hover:text-gray-900"
                  : "text-gray-200 hover:text-white"
              }`}
            >
              Áreas de Atuação
            </button>
            <button
              onClick={() => scrollToSection("contato")}
              className={`text-sm font-medium transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                scrolled
                  ? "text-gray-700 hover:text-gray-900"
                  : "text-gray-200 hover:text-white"
              }`}
            >
              Contato
            </button>
          </div>

          {/* Desktop Social Icons */}
          <div className="hidden md:flex items-center gap-4">
            <a
              href="https://www.instagram.com/dr.araujogabriel/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-all duration-300 cursor-pointer ${
                scrolled
                  ? "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
                  : "text-gray-300 hover:text-white hover:bg-white/10"
              }`}
            >
              <i className="ri-instagram-line text-lg"></i>
            </a>
            <a
              href="https://www.linkedin.com/in/gabriel-araujo-225638356/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-all duration-300 cursor-pointer ${
                scrolled
                  ? "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
                  : "text-gray-300 hover:text-white hover:bg-white/10"
              }`}
            >
              <i className="ri-linkedin-fill text-lg"></i>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer transition-colors duration-300 ${
              scrolled ? "text-gray-900" : "text-white"
            }`}
          >
            <i className={`${mobileMenuOpen ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white shadow-lg border-t border-gray-100">
            <div className="px-6 py-4 space-y-3">
              <button
                onClick={() => {
                  setMobileMenuOpen(false);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                className="block w-full text-left text-gray-700 hover:text-gray-900 text-sm font-medium py-2 cursor-pointer whitespace-nowrap"
              >
                Início
              </button>
              <button
                onClick={() => scrollToSection("sobre")}
                className="block w-full text-left text-gray-700 hover:text-gray-900 text-sm font-medium py-2 cursor-pointer whitespace-nowrap"
              >
                Sobre
              </button>
              <button
                onClick={() => scrollToSection("areas-atuacao")}
                className="block w-full text-left text-gray-700 hover:text-gray-900 text-sm font-medium py-2 cursor-pointer whitespace-nowrap"
              >
                Áreas de Atuação
              </button>
              <button
                onClick={() => scrollToSection("contato")}
                className="block w-full text-left text-gray-700 hover:text-gray-900 text-sm font-medium py-2 cursor-pointer whitespace-nowrap"
              >
                Contato
              </button>
              <div className="flex items-center gap-3 pt-2 border-t border-gray-100">
                <a
                  href="https://www.instagram.com/dr.araujogabriel/"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-9 h-9 flex items-center justify-center text-gray-600 hover:text-gray-900 cursor-pointer"
                >
                  <i className="ri-instagram-line text-lg"></i>
                </a>
                <a
                  href="https://www.linkedin.com/in/gabriel-araujo-225638356/"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-9 h-9 flex items-center justify-center text-gray-600 hover:text-gray-900 cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section
        id="inicio"
        className="relative min-h-screen flex items-center justify-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/b6d613a6fd5b832132f99eb6160a8a2c.jpg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/72 to-black/65"></div>

        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full pt-24">
          {/* Alert badge */}
          <div className="inline-flex items-center gap-2 bg-red-600/20 border border-red-500/40 text-red-300 text-xs font-semibold tracking-widest uppercase px-4 py-2 rounded-full mb-8">
            <i className="ri-error-warning-line text-sm"></i>
            Conta bloqueada judicialmente?
          </div>

          <p className="text-amber-400 text-4xl md:text-5xl lg:text-[3.4rem] font-bold tracking-wide mb-5 uppercase leading-tight">
            Sua conta foi bloqueada<br />judicialmente?
          </p>

          <h2 className="text-lg md:text-xl text-gray-200 font-normal max-w-2xl mx-auto leading-relaxed mb-6">
            Atuação rápida no pedido de desbloqueio de valores e na defesa do processo que originou o bloqueio, inclusive em execuções fiscais.
          </h2>

          <div className="w-20 h-px bg-gray-500 mx-auto mb-10"></div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={handleWhatsAppClick}
              className="inline-flex items-center gap-3 border border-white/40 hover:border-white/80 text-white hover:bg-white/10 px-10 py-4 rounded-full text-base font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              FALAR NO WHATSAPP
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
